// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

const WaterMarkContainer = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background-color: rgba(255, 255, 255, 0.7);
  justify-content: center;
  align-items: center;
  display: flex;

  .fav-redesign {
    display: flex;
    width: 214px;
    padding: 4px 32px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    background: #c8102e;
    box-sizing: border-box;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      width: auto;
      padding: 4px 8px;
    }
  }
`;

export const WaterMarkContainerNew = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  background-color: rgba(26, 26, 26, 0.4);
  justify-content: center;
  align-items: center;
  display: flex;
  .body-text-new {
    color: ${({ theme }) => theme.colors.WHITE};
    font-weight: ${({ theme }) => theme.fonts.fontWeight.extrabold};
    font-family: ${({ theme }) => theme.fonts.secondaryFontFamily};
    font-size: ${({ theme }) => theme.fonts.fontSize.body.bodytext.copy6}px;
    @media ${({ theme }) => theme.mediaQuery.smallOnly} {
      font-size: ${({ theme }) => theme.fonts.fontSize.body.bodytext.copy3}px;
    }
  }
`;

export default WaterMarkContainer;
